<template>
  <div class="info-card" :class="backgroundColor">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h5>{{ title }}</h5>
      <i class="fs-24" :class="icon" />
    </div>
    <div class="d-flex" :class="{ blur }">
      <h2>{{ prefix }}</h2>
      <h2>{{ value }}</h2>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    },
    prefix: {
      type: String,
      default: "R$"
    },
    backgroundColor: {
      type: String,
      default: "bg-2"
    },
    blur: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss" scoped>
.info-card {
  padding: 24px;
  border-radius: 16px;

  h2 {
    font-weight: 700;
  }
}
</style>
